import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'cep'
})
export class CepPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		let new_value = null;
		if(value){
			new_value = value.substr(0, 5);
			new_value += "-";
			new_value += value.substr(5, 3);
		}
		return new_value;
	}

}
